import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { IUser, IUserFilter } from './users.interface';
import { UserService } from './users.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { UsersModalComponent } from './users-modal/users-modal.component';
import * as _ from 'lodash';
import { CompanyRoleLabels, RoleLabels } from './users.constants';
import { ActivatedRoute } from '@angular/router';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  isManax: boolean = false;
  users: IUser[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: any = {
    filters: {
      isDeleted: false
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "username": 'Usuario asc',
    "-username": 'Usuario desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  roleLabels: any = CompanyRoleLabels;
  roleLabelsKeys = Object.keys(this.roleLabels);
  isAdmin: boolean = false;

  constructor(
    public _UserService: UserService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    public _AuthService: AuthService,
    private _route: ActivatedRoute,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewUserModal());
    })
  }

  ngOnInit() {
    this.isManax = this._AuthService.isManax();
    this.isDev = this._AuthService.isRole('dev');
    this.isAdmin = this._AuthService.isRole('admin');
    if (!this.isManax) this.filter.company = this._AuthService.companyId();
    if (this.isManax || this.isDev) {
      this.roleLabels = RoleLabels;
      this.roleLabelsKeys = Object.keys(this.roleLabels);
    }
    this.getUsers(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getUsers(true);
      }
    }, 1000);
  }

  getUsers(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.users = [];
      this.clearSelection();
    }
    this._UserService.getUsers(this.filter).subscribe((users: any) => {

      /* REFACTOR */
      if (this.isAdmin && !this.isDev && !this.isManax) {
        users = users.filter((usr: IUser) => {
          return ((usr.roles || []).filter(rol => (rol.name == 'manax' || rol.name == 'dev')).length) ? false : true;
        })
      }
      /* REFACTOR */

      // console.log(users);

      this.users = _.concat(this.users, users);
      this.thereAreMore = users.length > 0;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getUsers();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortUsers(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getUsers(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getUsers(true);
  }

  openNewUserModal() {
    this.openUsersModal({});
  }

  openUsersModal(user: IUser, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(UsersModalComponent, config);
    self.dialogRef.componentInstance.user = user;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getUsers(true);
    });
  }

  openDeleteUserConfirm(user: IUser, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Usuario",
      message: "Esta seguro que desea eliminar '" + user.username + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._UserService.deleteUser(user, hardDelete).subscribe(() => {
            if (!hardDelete) user.isDeleted = true;
            this.getUsers(true);
          })
        }
      });
  }

  openRestoreUserConfirm(user: IUser) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Usuario",
      message: "Esta seguro que desea restaurar '" + user.username + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._UserService.restoreUser(user).subscribe(() => {
            user.isDeleted = false;
            this.getUsers(true);
          })
        }
      });
  }

  openExportItems(all: boolean) {
    this.openUnderConstructionDialog();
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.users.every(user => {
        const id = user?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.users.forEach(user => {
        const id = user?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}